<template>
    <div v-if="error"
        style="width: 90%; display: flex; flex-direction: column; justify-content: center; align-items: center; margin-top:10rem;">
        <img src="/assets/myinvois/images/Error Page Image.png" alt="Logo" style="width: 40rem; margin: 1rem;" />
        <div class="error-box">
            <p style="margin-bottom: 0;">Invalid session link.<br>If you have any concern, please contact us at <span
                    style="font-weight:bold;"><a
                        :href="`mailto:${support_email_address}`">{{ support_email_address }}</a></span>
            </p>
        </div>
    </div>
    <div v-else style="width: 100%;">
        <div class="header-container">
            <img :src="logo_file_path" alt="Logo" style="width: 9rem; margin: 1rem;" />
            <h4>E-Invoice <br class="mobile-next"> Submission Form </h4>
        </div>
        <div class="form-container">
            <div style="background-color: #e4e4e4;" class="rounded" v-if="isSubmitted">
                <div style="display: flex; justify-content: center; margin-top: 20px;">
                    <svg  width="40px" height="40px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.5" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" fill="#008000"/>
                        <path d="M16.0303 8.96967C16.3232 9.26256 16.3232 9.73744 16.0303 10.0303L11.0303 15.0303C10.7374 15.3232 10.2626 15.3232 9.96967 15.0303L7.96967 13.0303C7.67678 12.7374 7.67678 12.2626 7.96967 11.9697C8.26256 11.6768 8.73744 11.6768 9.03033 11.9697L10.5 13.4393L12.7348 11.2045L14.9697 8.96967C15.2626 8.67678 15.7374 8.67678 16.0303 8.96967Z" fill="#ffffff"/>
                    </svg>
                </div>
                <p style="text-align: center; font-size: 14px; font-weight: bold; justify-content: center; margin: 8px;">
                    Congratulations! Your E-Invoice request has been successfully submitted.
                </p>
            </div>
            <p></p>
            <form @submit.prevent="submitForm">
                <div class="form-group">
                    <label for="pos_invoice_no">POS Invoice No <span style="color: red;">*</span></label>
                    <input type="text" v-model="formData.pos_invoice_no" placeholder="POS Invoice No" disabled />
                </div>
                <div class="form-group">
                    <label class="unstyled" for="date">Transaction Date (YYYY-MM-DD)<span
                            style="color: red;">*</span></label>
                    <input type="text" v-model="formData.date" placeholder="Date" disabled>
                </div>
                <div class="form-group">
                    <label for="store_name">Store Name <span style="color: red;">*</span></label>
                    <input type="text" v-model="formData.store_name" placeholder="Store Name" disabled />
                </div>
                <hr width="100%" size="4" noshade>
                <div>
                    <h5 style="font-size: medium; font-weight: bold; margin-bottom: 20px;">PERSONAL DETAILS</h5>
                    <p></p>
                </div>
                <div class="form-group">
                    <label for="full_name">Full Name (as per ID) <span style="color: red;">*</span></label>
                    <input type="text" v-model="formData.full_name" placeholder="e.g. Syatifah binti Ibrahim" required
                        :disabled="isSubmitted">
                </div>
                <div class="form-group">
                    <label for="email_address">Email Address <span style="color: red;">*</span></label>
                    <input id="email-field" type="text" v-model="formData.email_address"
                        placeholder="e.g. syatifah@gmail.com" required :disabled="isSubmitted">
                    <div style="font-size: 0.875rem;" class="form-error-msg">
                        <span v-if="form_error_data.email" style="color: red;">{{ form_error_data.email }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <label for="phone_number">Phone Number <span style="color: red;">*</span></label>
                    <input id="phone" type="tel" :disabled="isSubmitted" required />
                    <div style="font-size: 0.875rem;" class="form-error-msg">
                        <span v-if="form_error_data.phone" style="color: red;">{{ form_error_data.phone }}</span>
                    </div>
                </div>
                <label for="customer_type">Claim as:</label>
                <div style="display: flex; align-items: center; gap: 25px">
                    <div class="form-check" style="display: flex;">
                        <input class="form-check-input" type="radio" name="customer_type" value="Individual"
                            id="individual" v-model="formData.customer_type" required :disabled="isSubmitted"
                            :checked="formData.customer_type === 'Individual'">
                        <label class="form-check-label" for="individual" style="cursor: pointer;">
                            Individual
                        </label>
                    </div>
                    <div class="form-check" style="display: flex;">
                        <input class="form-check-input" type="radio" name="customer_type" value="Company" id="company"
                            v-model="formData.customer_type" required :disabled="isSubmitted"
                            :checked="formData.customer_type === 'Company'">
                        <label class="form-check-label" for="company" style="cursor: pointer;">
                            Company
                        </label>
                    </div>
                </div>
                <p></p>
                <hr v-if="formData.customer_type" width="100%" size="4" noshade>
                <div v-if="formData.customer_type === 'Individual'">
                    <h5 style="font-size: medium; font-weight: bold; margin-bottom: 20px;">INDIVIDUAL DETAILS</h5>
                    <p></p>
                    <label for="individual-type">Individual ID <span style="color: red;">*</span></label>
                    <div style="display: flex; align-items: center; gap: 15px; margin-bottom: 10px;">
                        <div class="form-check" style="display: flex;">
                            <input class="form-check-input" type="radio" name="identification_number_type" value="MyKad"
                                id="NRIC" v-model="formData.identification_number_type" required :disabled="isSubmitted"
                                :checked="formData.identification_number_type === 'MyKad'">
                            <label class="form-check-label" for="NRIC" style="cursor: pointer;">
                                MyKad
                            </label>
                        </div>
                        <div class="form-check" style="display: flex;">
                            <input class="form-check-input" type="radio" name="identification_number_type" id="Passport"
                                value="Passport" v-model="formData.identification_number_type" required
                                :disabled="isSubmitted" :checked="formData.identification_number_type === 'Passport'">
                            <label class="form-check-label" for="Passport" style="cursor: pointer;">
                                Passport
                            </label>
                        </div>
                        <div class="form-check" style="display: flex;">
                            <input class="form-check-input" type="radio" name="identification_number_type" id="Army"
                                value="MyTentera" v-model="formData.identification_number_type" required
                                :disabled="isSubmitted" :checked="formData.identification_number_type === 'MyTentera'">
                            <label class="form-check-label" for="Army" style="cursor: pointer;">
                                MyTentera
                            </label>
                        </div>
                    </div>
                    <div class="form-group">
                        <input type="text" @input="ignore_dash_character" v-model="formData.identification_number"
                            :placeholder="getPlaceholder(formData.identification_number_type)"
                            :required="formData.identification_number_type"
                            :disabled="isSubmitted || formData.identification_number_type === ''"
                            id="identification_number">
                        <div style="font-size: 0.875rem;" class="form-error-msg">
                            <span v-if="form_error_data.identification_number" style="color: red;">
                                {{ form_error_data.identification_number }}
                            </span>
                        </div>
                    </div>
                    <div class="form-group" style="margin-bottom: 10px;">
                        <label for="tax_id">Individual Tax Identification Number (TIN) <span
                                style="color: red;">*</span></label>
                        <input type="text" @input="ignore_dash_character" v-model="formData.individual_tin"
                            placeholder="e.g. C1212341234" :disabled="isSubmitted" id="individual_tin" required>
                        <div style="font-size: 0.875rem;" class="form-error-msg">
                            <span v-if="form_error_data.individual_tin" style="color: red;">{{
                                form_error_data.individual_tin }}</span>
                        </div>
                    </div>
                </div>
                <div v-else-if="formData.customer_type === 'Company'">
                    <h5 style="font-size: medium; font-weight: bold; margin-bottom: 20px;">COMPANY DETAILS</h5>
                    <p></p>
                    <div class="form-group" style="margin-bottom: 10px;">
                        <label for="company-name">Company Name <span style="color: red;">*</span></label>
                        <input type="text" v-model="formData.company_name" placeholder="e.g. Coffee Shop Sdn. Bhd."
                            required :disabled="isSubmitted">
                    </div>
                    <div class="form-group" style="margin-bottom: 10px;">
                        <label for="company-id">Company ID - Business Registration Number (BRN) <span
                                style="color: red;">*</span></label>
                        <input type="text" @input="ignore_dash_character" v-model="formData.company_id"
                            placeholder="e.g. 201909123456" required :disabled="isSubmitted" id="company_id">
                        <div style="font-size: 0.875rem;" class="form-error-msg">
                            <span v-if="form_error_data.company_id" style="color: red;">{{ form_error_data.company_id
                                }}</span>
                        </div>
                    </div>
                    <div class="form-group" style="margin-bottom: 10px;">
                        <label for="tax_id">Company Tax Identification Number (TIN) <span
                                style="color: red;">*</span></label>
                        <input type="text" @input="ignore_dash_character" v-model="formData.company_tin"
                            placeholder="e.g. C1212341234" :disabled="isSubmitted" id="company_tin" required>
                        <div style="font-size: 0.875rem;" class="form-error-msg">
                            <span v-if="form_error_data.company_tin" style="color: red;">{{ form_error_data.company_tin
                                }}</span>
                        </div>
                    </div>
                    <div class="form-group" style="margin-bottom: 10px;">
                        <label for="sst_registration_no">SST Registration Number (Mandatory for SST-registrant)</label>
                        <input type="text" @input="ignore_dash_character" v-model="formData.sst_number"
                            placeholder="e.g. X89-2104-12345678" :disabled="isSubmitted" id="company_sst_number">
                        <div style="font-size: 0.875rem;" class="form-error-msg">
                            <span v-if="form_error_data.company_sst_number" style="color: red;">{{
                                form_error_data.company_sst_number }}</span>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="address">Address Line 1 <span style="color: red;">*</span></label>
                    <input type="text" v-model="formData.address_line_1" placeholder="e.g. Unit No, Street Name"
                        :disabled="isSubmitted" required>
                </div>
                <div class="form-group">
                    <label for="address">Address Line 2 </label>
                    <input type="text" v-model="formData.address_line_2" placeholder="e.g. Unit No, Street Name"
                        :disabled="isSubmitted">
                </div>
                <div class="form-group">
                    <label for="country">Country <span style="color: red;" >*</span></label>
                    <Select pt:root:class="w-100"  :disabled="isSubmitted" v-model="formData.country" :options="countries_list" filter optionLabel="name" optionValue="name" placeholder="Select a Country" class="w-full md:w-56">
                    </Select>
                </div>
                <div class="form-group">
                    <label for="state">State <span style="color: red;">*</span></label>
                    <Select pt:root:class="w-100" :disabled="isSubmitted" v-model="formData.state" :options="filteredStateOptions" filter optionLabel="state" optionValue="name" placeholder="Select a State" class="w-full md:w-56">
                    </Select>
                </div>
                <div class="form-group">
                    <label for="city">City <span style="color: red;">*</span></label>
                    <!--State is not applicable and country is Malaysia-->
                    <select v-if="formData.state !== '17' && formData.country === 'Malaysia'" v-model="formData.city"
                        :class="{ 'select_background_white': !isSubmitted, 'select_background_grey': isSubmitted }"
                        required :disabled="isSubmitted">
                        <option v-for="city, index in cities()" :key="index" :value="city">
                            {{ city }}
                        </option>
                    </select>
                    <input type="text" v-else-if="formData.state === '17' && formData.country === 'Malaysia'"
                        placeholder="Please select a state in Malaysia!" disabled>
                    <input type="text" v-else-if="formData.state === '17' && formData.country !== 'Malaysia'"
                        v-model="formData.city" required :disabled="isSubmitted" placeholder="e.g. New York">
                    <input type="text" v-else-if="formData.state" placeholder="Select 'Not Applicable' on 'State'."
                        disabled>
                    <input type="text" v-else placeholder="Please choose 'State' first." disabled>
                </div>
                <div class="form-group">
                    <label for="city">Postal Code <span style="color: red;">*</span></label>
                    <input type="text" id="postal_code" v-model="formData.postal_code" placeholder="e.g. 43200" required
                        :disabled="isSubmitted">
                </div>
                <div class="form-group d-flex mt-8">
                    <input type="checkbox" id="agreement" v-model="formData.accept_privacy_policy_and_tac" required
                        :disabled="isSubmitted">
                    <label for="agreement" class="agreement-label">By ticking this box, you consent to abide by the
                        <a :href="`/terms-and-conditions`" target="_blank"
                            style="color: #6b68ff; text-decoration: underline;">Terms and Conditions</a> as well as <a
                            :href="`/privacy-policy`" target="_blank"
                            style="color: #6b68ff; text-decoration: underline;">Privacy Policy</a>
                        outlined herein. Please review the terms
                        carefully before proceeding. Your acceptance indicates your understanding and agreement to be
                        bound by these terms.</label>
                    <div style="font-size: 0.875rem;" class="form-error-msg">
                        <span v-if="form_error_data.agreement" style="color: red;">{{ form_error_data.agreement
                            }}</span>
                    </div>
                </div>
                <div class="form-actions">
                    <button type="submit" class="btn-primary" :class="{ 'btn-success': isSubmitted }"
                        :disabled="isSubmitting || isSubmitted" style="border-radius: 2rem; font-weight: bold;">
                        {{ isSubmitted ? "Submitted" : (isSubmitting ? "Submitting..." : "Submit") }}
                    </button>
                </div>
            </form>
            <div style="text-align: center; margin-top: 2rem; color: #398bff; font-size: 14px;">
                Powered by <a :href="`https://www.byondwave.com/`" target="_blank"
                    style="color: #398bff;">BYONDWAVE.com</a>
            </div>
        </div>
    </div>
</template>

<script>
import { getCities } from "malaysia-postcodes";
import Select from 'primevue/select';
export default {
    components: { Select },
    props: ["customer_session_id"], 
    data() {
        return {
            countries_list: [],
            stateOptions: [],
            logo_file_path: "",
            phone_instance: null,
            formData: {
                customer_session_id: this.customer_session_id,
                pos_invoice_no: "",
                date: '',
                store_name: '',
                accept_privacy_policy_and_tac: false,

                //Personal details
                full_name: '',
                email_address: '',
                phone_number: '',
                customer_type: 'Individual',

                //Individual details
                identification_number_type: '',
                identification_number: '',
                individual_tin: '',

                //Company details
                company_name: '',
                company_id: '',
                company_tin: '',
                sst_number: '',

                //Address details
                address_line_1: '',
                address_line_2: '',
                country: '',
                state: '',
                city: '',
                postal_code: '',
            },
            form_error_data: {},
            isSubmitting: false, // Tracks if the form is being submitted
            isSubmitted: false,
            error: false,
            support_email_address: "",
        };
    },
    computed: {
        filteredStateOptions() {
            // Filter out "All State"
            return this.stateOptions.filter(option =>
                // option.state !== 'All States'
                option.name !== "00"
            )
        },
    },
    watch: {
        "formData.customer_type": function (newVal) {
            this.form_error_data = {};
            // Clear irrelevant fields based on the selected customer type
            if (newVal === "Individual") {
                this.formData.company_name = "";
                this.formData.company_id = "";
                this.formData.company_tin = "";
                this.formData.sst_number = "";
            } else if (newVal === "Company") {
                this.formData.individual_address = "";
                this.formData.identification_number_type = "";
                this.formData.identification_number = "";
                this.formData.individual_tin = "";
            }
        },
    },
    methods: {
        getPlaceholder(type) {
            switch (type) {
                case 'MyKad': return 'e.g. 971213081234';
                case 'Passport': return 'e.g. A12345678';
                case 'MyTentera': return 'e.g. 971213081234';
                default: return 'Please select identification number type!';
            }
        },
        cities() {
            //Convert state code (.name) to state name (.state)
            state_name = "";
            const selectedState = this.stateOptions.find(
                state_code => state_code.name === this.formData.state
            );
            if (selectedState) {
                state_name = selectedState.state;
            }
            // Return cities dictionary for primevue Select component
            if (state_name === 'Wilayah Persekutuan Kuala Lumpur') //The library only recognise "Wp Kuala Lumpur", "Wp Labuan" and "Wp Putrajaya"
                return [{'name': 'Kuala Lumpur'}]
            else if (state_name === 'Wilayah Persekutuan Labuan')
                return [{'name': "Labuan"}]
            else if (state_name === 'Wilayah Persekutuan Putrajaya')
                return [{'name': "Putrajaya"}]
            else if (state_name === 'Pulau Pinang')
                state_name = "Penang"
            return getCities(state_name).map(city => {return {'name': city};});
        },
        get_pos_invoice_no() {
            frappe.call({
                method: "myinvois.api.get_pos_invoice_no",
                args: {
                    customer_session_id: this.customer_session_id,
                },
                callback: (response) => {
                    if (response.success) {
                        this.formData.pos_invoice_no = response.message.pos_invoice_no;
                        this.formData.store_name = response.message.store_name;
                        this.formData.date = response.message.transaction_date;
                        this.logo_file_path = response.message.logo_file_path;
                    } else {
                        this.error = true;
                        this.support_email_address = response.message.support_email_address;
                    }
                }
            });
        },
        validate_form() {
            let isValid = true;
            this.form_error_data = {}; // Clear previous errors
            const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
            const passportPattern = /^[AHKahk]\d{8}$/;
            const individualTINPattern = /^(IG)(\d{9,11})$/;
            const nonIndividualTINPattern = /^[CDEF](\d{9,11})0$/;
            const nricPattern = /^\d{6}\d{2}\d{4}$/;
            const brnPattern = /^\d{4}(01|02|03|04|05|06)\d{6}$/;
            const sstRegNoPattern = /^[A-Z]\d{2}\d{4}\d{8}$/;
            const email_input = document.querySelector("#email-field");
            const phone_input = document.querySelector("#phone");
            const identification_number_input = document.querySelector("#identification_number");
            const individual_tin_input = document.querySelector("#individual_tin");
            const company_tin_input = document.querySelector("#company_tin");
            const company_id_input = document.querySelector("#company_id");
            const company_sst_number_input = document.querySelector("#company_sst_number");

            const patterns = {
                'MyKad': nricPattern,
                'MyTentera': nricPattern,
                'Passport': passportPattern,
            };

            if (this.formData.customer_type === "Individual") {
                // Identification Number Type
                if (this.formData.identification_number_type) {
                    // Identification Number
                    if (identification_number_input) {
                        const value = this.formData.identification_number;
                        const pattern = patterns[this.formData.identification_number_type];
                        const errorMessage = `Please enter a valid ${this.formData.identification_number_type} number.`;
                        if (!value || value === null || !pattern.test(value)) {
                            this.form_error_data.identification_number = errorMessage;
                            isValid = false;
                            identification_number_input.style.borderColor = "red";
                        } else {
                            identification_number_input.style.borderColor = "";
                        }
                    } else {
                        console.error(`${this.formData.identification_number_type.toUpperCase()} input element not found.`);
                    }
                } else {
                    console.error("Identification number type is not specified.");
                }

                // Individual TIN
                if (!this.formData.individual_tin || this.formData.individual_tin === null || !individualTINPattern.test(this.formData.individual_tin)) {
                    this.form_error_data.individual_tin = "Please enter a valid TIN.";
                    isValid = false;
                    individual_tin_input.style.borderColor = "red";
                } else {
                    individual_tin_input.style.borderColor = "";
                }
            }

            // Company 
            if (this.formData.customer_type === "Company") {
                // Company TIN
                if (!this.formData.company_tin || this.formData.company_tin === null || !nonIndividualTINPattern.test(this.formData.company_tin)) {
                    this.form_error_data.company_tin = "Please enter a valid TIN.";
                    isValid = false;
                    company_tin_input.style.borderColor = "red";
                } else {
                    company_tin_input.style.borderColor = "";
                }
                // Company BRN / Company ID
                if (!this.formData.company_id || this.formData.company_id === null || !brnPattern.test(this.formData.company_id)) {
                    this.form_error_data.company_id = "Please enter a valid BRN.";
                    isValid = false;
                    company_id_input.style.borderColor = "red";
                } else {
                    company_id_input.style.borderColor = "";
                }
                // Company SST Registration No
                if (this.formData.sst_number !== "" && !sstRegNoPattern.test(this.formData.sst_number)) {
                    this.form_error_data.company_sst_number = "Please enter a valid SST Registration No.";
                    isValid = false;
                    company_sst_number_input.style.borderColor = "red";
                } else {
                    company_sst_number_input.style.borderColor = "";
                }
            }

            // Email Address
            if (!this.formData.email_address || !emailPattern.test(this.formData.email_address)) {
                this.form_error_data.email = "Please enter a valid email address.";
                isValid = false;
                email_input.style.borderColor = "red";
            } else {
                email_input.style.borderColor = "";
            }
            // Phone Number
            if (!this.phone_instance) {
                if (!phone_input.value) {
                    this.form_error_data.phone = "Please enter a phone number.";
                    isValid = false;
                    phone_input.style.borderColor = "red";
                } else {
                    phone_input.style.borderColor = "";
                }
            } else {
                const isValidPhone = this.phone_instance.isValidNumber();
                if (!isValidPhone) {
                    this.form_error_data.phone = "Please enter a valid phone number.";
                    isValid = false;
                    phone_input.style.borderColor = "red";
                } else {
                    phone_input.style.borderColor = "";
                }
            }
            return isValid;
        },
        submitForm() { //Fill in the E-Invoice Request record.
            if (this.isSubmitting || this.isSubmitted) return;
            const isValid = this.validate_form();
            if (!isValid) return;
            this.update_phone_number();
            this.isSubmitting = true;
            frappe.call({
                method: "myinvois.api.create_einvoice_request_record",
                args: { formData: this.formData },
                callback: (response) => {
                    if (response.success) {
                        this.isSubmitted = true;
                        frappe.show_alert({
                            title: "Success",
                            indicator: "green",
                            message: "Data submitted successfully.",
                        });
                    }
                    else {
                        frappe.msgprint({
                            title: "Invalid",
                            indicator: "red",
                            message: response.message,
                        });
                    }
                },
                error: () => {
                    this.isSubmitting = false;
                }
            });
        },
        fetchValues() { // Map back the E-Invoice Request Record if it is submitted.
            frappe.call({
                method: "myinvois.api.fetch_einvoice_request_record",
                args: {
                    customer_session_id: this.customer_session_id
                },
                callback: (response) => {
                    if (response.success) {
                        einvoice_request_doc = response['einvoice_request_doc'];
                        if (einvoice_request_doc.docstatus == 1) {
                            this.isSubmitted = true; //disabled the form inputs
                            //Personal details
                            this.formData.full_name = einvoice_request_doc.full_name;
                            this.formData.email_address = einvoice_request_doc.email_address;
                            this.formData.customer_type = einvoice_request_doc.customer_type;
                            this.formData.address_line_1 = einvoice_request_doc.address_line_1;
                            this.formData.address_line_2 = einvoice_request_doc.address_line_2;
                            this.formData.state = einvoice_request_doc.state;
                            this.formData.city = einvoice_request_doc.city;
                            this.formData.country = einvoice_request_doc.country;
                            this.formData.postal_code = einvoice_request_doc.postal_code;
                            this.formData.accept_privacy_policy_and_tac = Boolean(einvoice_request_doc.accept_privacy_policy_and_tac);
                            // Update intl-tel-input instance with the fetched phone number
                            if (this.phone_instance) {
                                this.phone_instance.setNumber(einvoice_request_doc.mobile_number);
                            }
                            //Individual details
                            if (einvoice_request_doc.customer_type == "Individual") {
                                this.formData.identification_number_type = einvoice_request_doc.identification_number_type;
                                this.formData.identification_number = einvoice_request_doc.identification_number;
                                this.formData.individual_tin = einvoice_request_doc.individual_tin;
                            }
                            //Company details
                            else if (einvoice_request_doc.customer_type == "Company") {
                                this.formData.company_name = einvoice_request_doc.company_name;
                                this.formData.company_id = einvoice_request_doc.company_id;
                                this.formData.company_tin = einvoice_request_doc.company_tin;
                                this.formData.sst_number = einvoice_request_doc.sst_registration_no;
                            }

                        }
                    }
                },

            })
        },
        initPhoneInput() {
            const phone_input = document.querySelector("#phone");
            if (!phone_input) {
                console.error("Phone input element not found!");
                return;
            }
            this.phone_instance = intlTelInput(phone_input, {
                initialCountry: "my",
                loadUtils: () => import("https://cdn.jsdelivr.net/npm/intl-tel-input@25.2.0/build/js/utils.js"),
                separateDialCode: true,
                useFullscreenPopup: false,
                autoPlaceholder: "aggressive"
            });
            phone_input.addEventListener("input", this.update_phone_number);
            phone_input.addEventListener("countrychange", this.update_phone_number);
        },
        update_phone_number() {
            if (this.phone_instance) {
                const formatted_number = this.phone_instance.getNumber();
                const is_valid = this.phone_instance.isValidNumber();
                if (is_valid !== false) {
                    this.formData.phone_number = formatted_number;
                }
            }
        },
        ignore_dash_character(event) {
            const inputElement = event.target;
            inputElement.value = inputElement.value.replace(/-/g, ''); // Remove "-" from input while typing in.
        },
        get_country_and_state_codes() {
            frappe.call({
                method: "myinvois.api.get_country_and_state_codes",
                args: {},
                callback: (response) => {
                    if (response.message) {
                        this.stateOptions = response.message.state_codes;
                        this.countries_list = response.message.countries;
                    }
                }
            });
        },
    },
    mounted() {
        this.get_pos_invoice_no();
        this.get_country_and_state_codes();
        this.fetchValues();
        this.$nextTick(() => {
            this.initPhoneInput();
        });
    },
    beforeUnmount() {
        // Clean up the intl-tel-input instance
        if (this.phone_instance) {
            this.phone_instance.destroy();
        }
    },
};
</script>

<style scoped>
.header-container {
    text-align: center;
    background-color: #3663e6;
    padding: 20px;
    max-width: 600px;
    margin: 3rem auto 0 auto;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
}

h4 {
    color: white;
    margin-top: 1.2rem;
    margin-bottom: 0.5rem;
    font-weight: bold;
}

.form-container {
    background: white;
    padding: 20px 50px;
    max-width: 600px;
    margin: 0rem auto 3rem auto;
    display: flex;
    flex-direction: column;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    border-bottom-left-radius: 1rem;
    border-bottom-right-radius: 1rem;
}

.form-group {
    margin-bottom: 20px;
}

label {
    font-weight: 600;
    display: block;
    margin-bottom: 8px;
    color: #555;
}

input {
    border-radius: 10px !important;
}

input:not([type="radio"]),
select {
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 10px;
    font-size: 14px;
    transition: border-color 0.2s ease;
}

input:focus,
select:focus {
    border-color: #007bff;
    outline: none;
}

.form-actions {
    text-align: center;
}

.btn-primary {
    background-color: #007bff;
    border: none;
    color: white;
    padding: 10px 20px;
    font-size: 16px;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.btn-primary:hover {
    background-color: #0056b3;
}

.example-text {
    color: #93999c;
    margin-bottom: 5px;
    font-size: 14px;
}

.mobile-next {
    display: none;
}

.error-box {
    background-color: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
    border-radius: 5px;
    margin: 0 2rem;
    padding: 20px;
    font-size: 16px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-success {
    background-color: #28a745;
    color: white;
    border-color: #28a745;
}

.select_background_white {
    background-color: white;
    color: black;
}

.select_background_grey {
    background-color: #f8f8f8;
    color: black;
}

.unstyled {
    appearance: none;
    -webkit-appearance: none;
}

.unstyled::-webkit-inner-spin-button,
.unstyled::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
}

label {
    font-size: 1rem;
}

#agreement {
    border-radius: 6px !important;
    margin: 5px 11px 0 0 !important;
    padding: 8px;
}

.agreement-label {
    cursor: pointer;
    font-size: 14px;
    text-align: justify;
}

@media (max-width: 575.99px) {
    .header-container {
        margin: 1rem 2rem 0 2rem;
    }

    .form-container {
        margin: 0rem 2rem 1rem 2rem;
        padding: 20px;
    }

    .mobile-next {
        display: block;
    }

    h4 {
        font-size: 1.5rem;
    }

    label {
        font-size: 0.875rem;
    }

    .agreement-label {
        font-size: 12px;
    }
}
</style>